module.exports = __webpack_public_path__ + "img/gobackXG.1a74a7e7.png";